import type { PaletteCommand } from '@patchbay/ui'
import { BookOpen, LifeBuoy } from 'lucide-react'
import { helpForPathname } from '../../lib/help/links'

/**
 * Ctrl+K "Help" commands (docs/help-centre.md). Owner: slice 36 `web-help-centre`; slice 14 `web-shell` spreads these
 * into AppPalette's command list:
 *   ...helpPaletteCommands({ pathname, go: (href) => navigate({ href }) })
 */
export function helpPaletteCommands({ pathname, go }: { pathname: string; go: (href: string) => void }): PaletteCommand[] {
  const here = helpForPathname(pathname)
  return [
    ...(here
      ? [
          {
            id: 'help-here',
            group: 'Help',
            label: 'Help for this page',
            icon: <LifeBuoy />,
            keywords: ['help', 'guide'],
            onSelect: () => go(here),
          },
        ]
      : []),
    {
      id: 'help-centre',
      group: 'Help',
      label: 'Help centre',
      icon: <BookOpen />,
      keywords: ['help', 'guide', 'docs', 'how'],
      onSelect: () => go('/help'),
    },
  ]
}
